<script>
import { computed } from "vue";
import {isNotEmpty} from "@/tools/utils";
export default {
    name: 'piece-form-item',
    props: ['formItem'],
    inject: ['baseData'],
    setup(prop, context) {
      let node = computed(() => prop.formItem);
      return{
        node
      }
    },
    methods: {
        show(evt){
            this.$emit('show', evt)
        },
        hide(evt){
            this.$emit('hide', evt)
        },
        isValNotEmpty(value){
          return isNotEmpty(value);
        }
    },
    computed: {
        sourceVariantOrigin(){
            if(this.node.variant && this.node.variant.origin){
                return this.$store.getters[this.node.variant.origin[0]+'/'+this.node.variant.origin[1]]
            }
            return []
        },
        select_options(){
            if(this.node.type=='select') {
                if (this.node.variant.options){
                    return this.node.variant.options
                }else{
                    let d = this.sourceVariantOrigin
                    let options = []
                    d.forEach(it=>{
                        options.push({
                            label: it[this.node.variant.fields[0]],
                            value: it[this.node.variant.fields[1]]
                        })
                    })

                    return options
                }

            }
            return []
        },


    },
    created(){
        let options = this.select_options
        if(options.length>0){
            if(this.node.variant.auto_assignment){
                this.node.value = options[0].value
            }
        }
    }


}
</script>
<template>
    <div class="com-form-item">
        <q-select v-if="node.type=='select'" :style="{width: node.minWidth}" dense clearable outlined filled transition-show="jump-up" transition-hide="jump-up"
        v-model="node.value" :options="select_options" emit-value map-options :error="isValNotEmpty(node.msg)" :error-message="node.msg">
        </q-select>
        <q-input v-if="node.type=='input'" :style="{minWidth: node.minWidth}" dense :outlined="node.outlined" :filled="node.filled" v-model="node.value"
        :disable="node.disable" :placeholder="node.placeholder" :error="isValNotEmpty(node.msg)" :error-message="node.msg">
            <template v-slot:after v-if="node.append && node.append.after">
                <!-- <q-btn v-if="node.append.after.btn" :label="node.append.after.btn.label" size="md" color="primary" /> -->
                <q-icon  v-if="node.append.after.btn.icon" :name="node.append.after.btn.icon" />
            </template>
        </q-input>
        <q-input v-if="node.type=='textarea'" class="my-textarea" type="textarea" :outlined="node.outlined" :filled="node.filled" v-model="node.value"
        :disable="node.disable" :rows="node.rows" :placeholder="node.placeholder" :error="isValNotEmpty(node.msg)" :error-message="node.msg"/>
        <q-btn dense v-if="node.type=='submit'" size="md" :label="node.label" color="primary" />
        <q-btn-dropdown
            v-if="node.type=='fold'"
            v-model="baseData.showQuery"
            persistent
            dense
            flat
            color="primary"
            :label="node.label"
            @show="show"
            @hide="hide"
        >
        </q-btn-dropdown>
    </div>
</template>
<style lang="scss" scoped>
//type为input时的字体高度
.com-form-item ::v-deep {
    .q-textarea.q-field--dense .q-field__native {
      padding-top: 1px;
      white-space: nowrap;
      overflow: hidden;
    }
    .q-field--auto-height.q-field--dense .q-field__native {
      min-height: $inputHeight;
      padding-top: 3px;
    }
  ::v-deep .my-textarea .q-field__inner .q-field__control .q-field__control-container .q-field__native{
    padding-top:0px !important;
  }
}
</style>
